<template>
  <div>
    <placeholder
      v-if="!record.candidate.id && !error.serverError"
      title="Loading record info..."
    ></placeholder>
    <div class="row  u-fill-width" v-else>
      <div class="col-6">
        <h6 class="font-light">Candidate</h6>
        <table class="table bordered">
          <tbody>
            <tr>
              <th>
                Name
              </th>
              <td>
                {{ record.candidate.full_name }}
              </td>
            </tr>
            <tr>
              <th>
                ARN
              </th>
              <td>
                {{ record.candidate.arn }}
              </td>
            </tr>
            <tr>
              <th>
                Signature
              </th>
              <td>
                <signature-status
                  class="u-center"
                  v-bind:signature="record.candidate_signature"
                  v-bind:role="'candidate'"
                  v-bind:module="'records'"
                  v-bind:dt="record.candidate_signature_dt"
                >
                </signature-status>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="col-6">
        <h6 class="font-light">Instructor</h6>
        <table class="table bordered">
          <tbody>
            <tr>
              <th>
                Name
              </th>
              <td>
                {{ record.instructor.full_name }}
              </td>
            </tr>
            <tr>
              <th>
                ARN
              </th>
              <td>
                {{ record.instructor.arn }}
              </td>
            </tr>
            <tr>
              <th>
                Signature
              </th>
              <td>
                <signature-status
                  class="u-center"
                  v-bind:signature="record.instructor_signature"
                  v-bind:role="'instructor'"
                  v-bind:module="'records'"
                  v-bind:dt="record.instructor_signature_dt"
                >
                </signature-status>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import Placeholder from "@/components/Placeholder";
import SignatureStatus from "@/components/SignatureStatus";

export default {
  name: "record-info",
  props: {
    record: {}
  },
  components: {
    Placeholder,
    SignatureStatus
  },
  computed: {
    ...mapGetters("core", ["error"])
  }
};
</script>
